import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'wl-ephemeral-content-swap',
  templateUrl: './ephemeral-content-swap.component.html',
  styleUrls: ['./ephemeral-content-swap.component.less'],
  standalone: false
})
export class EphemeralContentSwapComponent implements OnInit {
  @Input() hideDelay = 3000;
  showEphemeral = false;

  constructor() {}

  ngOnInit() {}

  public show() {
    this.showEphemeral = true;
    setTimeout(() => {
      this.showEphemeral = false;
    }, this.hideDelay);
  }
}
